// 演出の効果音・振動の ON/OFF（端末ごとの好みなので localStorage に保存。既定 ON）。
// プライベートブラウズ等で localStorage が使えない場合は既定値で動かす。
const KEY = 'effectSoundEnabled'

export function isEffectSoundEnabled(): boolean {
  try {
    return localStorage.getItem(KEY) !== '0'
  } catch {
    return true
  }
}

export function setEffectSoundEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(KEY, enabled ? '1' : '0')
  } catch {
    // 保存できなくても今回の操作には影響しない
  }
}
